import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { AuthModal } from "@/components/AuthModal";
import { InquiryModal } from "@/components/InquiryModal";
import { HomeHero } from "@/components/sections/HomeHero";
import { Paths } from "@/components/sections/Paths";
import { SIShowcase } from "@/components/sections/SIShowcase";
import { Shop } from "@/components/sections/Shop";
import { TrustStrip } from "@/components/sections/TrustStrip";
import { GrantsPricing } from "@/components/sections/GrantsPricing";
import { Partnership } from "@/components/sections/Partnership";
import { FAQ } from "@/components/sections/FAQ";
import { ConsultCTA } from "@/components/sections/ExploreCards";
import { useReveal } from "@/hooks/use-reveal";
import { useAuth } from "@/context/AuthContext";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function Landing() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [authOpen, setAuthOpen] = useState(false);
    const [checkingOut, setCheckingOut] = useState(null);
    const [inquiry, setInquiry] = useState({ open: false, product: "", type: "consultation", title: "Request a consultation" });

    const openInquiry = (product = "", type = "consultation", title = "Request a consultation") =>
        setInquiry({ open: true, product, type, title });

    useReveal([]);

    const goPath = (id) => {
        if (id === "paths") { document.getElementById("paths")?.scrollIntoView({ behavior: "smooth" }); return; }
        navigate(`/services#${id}`);
    };

    const checkout = async (lookup_key) => {
        setCheckingOut(lookup_key);
        try {
            const { data } = await api.post("/payments/checkout", { lookup_key, origin_url: window.location.origin, user_id: user?.id || null });
            window.location.href = data.checkout_url;
        } catch (e) {
            toast.error(apiError(e.response?.data?.detail) || "Checkout failed");
            setCheckingOut(null);
        }
    };

    return (
        <div className="min-h-screen bg-white">
            <Header dark onSignIn={() => setAuthOpen(true)} onConsult={() => openInquiry()} />
            <main>
                <HomeHero onPath={goPath} />
                <Paths />
                <GrantsPricing />
                <SIShowcase onTalk={() => navigate("/strategizer")} onAutomation={() => navigate("/services#automation")} />
                <Shop onCheckout={checkout} checkingOut={checkingOut} />
                <Partnership />
                <TrustStrip />
                <FAQ />
                <ConsultCTA onConsult={() => openInquiry()} />
            </main>
            <Footer onInquire={(p) => openInquiry(p)} onSignIn={() => setAuthOpen(true)} />
            <AuthModal open={authOpen} onOpenChange={setAuthOpen} onSuccess={() => navigate("/dashboard")} />
            <InquiryModal open={inquiry.open} onOpenChange={(v) => setInquiry((s) => ({ ...s, open: v }))} product={inquiry.product} type={inquiry.type} title={inquiry.title} />
        </div>
    );
}
